const selectElementsBySelector = (selector, selectedSoFar) => {
  const firstSelector = selector[0];

  if (Array.isArray(firstSelector)) {
    return selector
      .map(subSelector => selectElementsBySelector(subSelector, selectedSoFar))
      .reduce((x, y) => x.concat(y), []);
  }

  const selectedNew = selectedSoFar.findByName(firstSelector);

  if (selector.length > 1) {
    return selectElementsBySelector(selector.slice(1), selectedNew);
  }

  return selectedNew;
};

export default selectElementsBySelector;
